<template>
  <v-layout>
    <v-flex xs12 sm12 md12 lg10 offset-lg1>
      <v-container fluid>
        <v-card>
          <v-card-title>
            <h3 v-if="this.$auth.check('EXPERT')" class="headline pa-1">{{ $t('questionnaires.TITLE_PLURAL') }}</h3>
            <h3 v-else class="headline pa-1">{{ $t('questionnaires.TITLE') }}</h3>
            <v-spacer></v-spacer>
            <v-text-field
              v-if="this.$auth.check('EXPERT')"
              append-icon="search"
              :label="$t('forms.SEARCH')"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            v-if="this.$auth.check('EXPERT')"
            v-bind:headers="headersExpert"
            v-bind:search="search"
            v-bind:pagination.sync="pagination"
            :items="orderedQuestionnairesList"
            :rows-per-page-text="$t('results.table.ROWSPERPAGE')"
            :rows-per-page-items="rowsPageItems"
            class="elevation-1">
            <template slot="items" slot-scope="props" >
              <tr v-bind:class="{'grey lighten-2': !props.item.control}">
                <td>{{props.item.creationDate | formatDate}}</td>
                <td>{{props.item.teacherName}}</td>
                <td>{{props.item.schoolName}}</td>
                <td>{{props.item.level ? levelsMap[props.item.level] : '-'}}</td>
                <td>{{props.item.group ? groupsMap[props.item.group] : '-'}}</td>
                <td>{{props.item.subject ? props.item.subject : '-'}}</td>
                <td>
                  <v-icon v-if="props.item.control">check</v-icon>
                  <v-icon v-else>remove</v-icon>
                </td>
                <td>{{props.item.expertName || "-"}}</td>
                <td>
                  <v-tooltip top>
                    <v-btn icon v-on:click="$router.push({ name: 'Questionnaire', params: {questionnaireId: props.item.id} })" slot="activator">
                      <v-icon>forward</v-icon>
                    </v-btn>
                    <span>{{ $t('questionnaires.tooltips.ANSWER') }}</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-data-table
            v-if="this.$auth.check('TEACHER')"
            v-bind:headers="headersTeacher"
            v-bind:pagination.sync="pagination"
            :items="orderedQuestionnairesList"
            :rows-per-page-text="$t('results.table.ROWSPERPAGE')"
            :no-results-text="$t('results.table.NORESULTS')"
            :rows-per-page-items="rowsPageItems"
            class="elevation-1">
            <template slot="items" slot-scope="props">
              <td>{{props.item.creationDate | formatDate}}</td>
              <td>{{props.item.level ? levelsMap[props.item.level] : '-'}}</td>
              <td>{{props.item.group ? groupsMap[props.item.group] : '-'}}</td>
              <td>{{props.item.subject ? props.item.subject : '-'}}</td>
              <td>{{props.item.activityDescription}}</td>
              <td>
                <v-tooltip>
                  <v-btn icon v-on:click="openTeacherQuestionnaireStarter(props.item.id)" slot="activator">
                    <v-icon>forward</v-icon>
                  </v-btn>
                  <span>{{ $t('questionnaires.tooltips.ANSWER') }}</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
    </v-flex>

    <v-dialog v-model="showDialogSchoolTeacher" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline">{{ $t('questionnaires.new.SELECT') }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs8 offset-xs2>
              <v-select
                v-bind:items="schools"
                item-text="name"
                item-value="id"
                v-model="newQuestionnaire.schoolId"
                :label="$t('questionnaires.new.SCHOOL_SELECT')"
                autocomplete
                required
                v-show="this.$auth.check('EXPERT')"
              >
                <template slot="selection" slot-scope="data">{{ data.item.name }}</template>
                <template slot="item" slot-scope="data">{{ data.item.name }}</template>
              </v-select>
            </v-flex>
            <v-flex xs8 offset-xs2>
              <v-select
                v-bind:items="teachers"
                item-text="name"
                item-value="id"
                v-model="newQuestionnaire.teacherId"
                :label="$t('questionnaires.new.TEACHER_SELECT')"
                :disabled="!canSelectTeacher"
                required
                v-show="this.$auth.check('EXPERT')"
              >
                <template slot="selection" slot-scope="data">

                    <v-avatar>
                      <v-icon>person</v-icon>
                    </v-avatar>
                    {{ data.item.surname1 + ' ' + data.item.surname2 + ', ' + data.item.name}}

                </template>

                <template slot="item" slot-scope="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-avatar>
                      <v-icon>person</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.surname1 + ' ' + data.item.surname2 + ', ' + data.item.name"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="data.item.username"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>

              </v-select>
            </v-flex>
            <v-progress-circular v-bind:size="50" indeterminate class="primary--text" v-show="loading"></v-progress-circular>
            <v-flex xs6 offset-xs3>
              <v-menu
                lazy
                :close-on-content-click="true"
                v-model="datemenu"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                :disabled="disableDatePicker"
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  :label="$t('questionnaires.new.DATE_SELECT')"
                  :value="newQuestionnaire.date | formatDate"
                  prepend-icon="event"
                  :disabled="disableDatePicker"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="newQuestionnaire.date" no-title scrollable actions
                               :first-day-of-week="1"
                               :locale="locale">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs3 offset-xs2>
              <v-text-field
                :label="$t('questionnaires.new.DEGREE')"
                v-model="newQuestionnaire.degree"
                type="text"
                :disabled="disableDegree"
                required></v-text-field>
            </v-flex>

            <v-flex xs3 offset-xs2>
              <v-text-field
                :label="$t('questionnaires.new.FACULTY')"
                v-model="newQuestionnaire.faculty"
                type="text"
                :disabled="disableFaculty"
                required></v-text-field>
            </v-flex>

            <v-flex xs3 offset-xs2>
              <v-select
                :items="subjects"
                v-model="newQuestionnaire.subject"
                :label="$t('questionnaires.new.SUBJECT')"
                :disabled="disableSubject || (subjects == null || subjects.length <= 0)"
                required
              >
              </v-select>
            </v-flex>

            <v-flex xs3 offset-xs2>
              <v-text-field
                :label="$t('questionnaires.new.KIDS_NUMBER')"
                v-model="newQuestionnaire.kidsNumber"
                type="number"
                :disabled="disableKidsNumber"
                required></v-text-field>
            </v-flex>
            <v-flex xs10 offset-xs1>
              <v-textarea
                :label="$t('questionnaires.new.ACTIVITY_DESCRIPTION')"
                :placeholder="$t('questionnaires.new.help.GROUPING') + '\n'
                + $t('questionnaires.new.help.GOAL') + '\n'
                + $t('questionnaires.new.help.ACTIVITY') + '\n'
                + $t('questionnaires.new.help.RESOURCES') + '\n'
                + $t('questionnaires.new.help.PARTICIPATION') + '\n'
                + $t('questionnaires.new.help.ASSESSMENT') + '\n'
                + $t('questionnaires.new.help.ATMOSPHERE') + '\n'"
                v-model="newQuestionnaire.activityDescription"
                rows="6"
                textarea
                multi-line
                auto-grow
                required>
                <template slot="append">
                  <v-btn icon v-on:click.stop="showDescriptionHelp=true">
                    <v-icon>help</v-icon>
                  </v-btn>
                </template>
              </v-textarea><v-flex xs10 offset-xs1>
              <v-layout v-if="newQuestionnaire.activityDescription">
                <ul>
                  <li>{{$t('questionnaires.new.help.GROUPING')}}</li>
                  <li>{{$t('questionnaires.new.help.GOAL')}}</li>
                  <li>{{$t('questionnaires.new.help.ACTIVITY')}}</li>
                  <li>{{$t('questionnaires.new.help.PARTICIPATION')}}</li>
                </ul>
                <ul>
                  <li>{{$t('questionnaires.new.help.RESOURCES')}}</li>
                  <li>{{$t('questionnaires.new.help.ASSESSMENT')}}</li>
                  <li>{{$t('questionnaires.new.help.ATMOSPHERE')}}</li>
                </ul>
              </v-layout>
            </v-flex>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn class="red--text" v-if="this.questionnaires.length < 1" flat
                 @click.native="$router.push({ name: 'Home' })">{{ $t('questionnaires.new.CLOSE') }}</v-btn>
          <v-btn class="red--text" v-else flat
                 @click.native="closeStartDialog">{{ $t('questionnaires.new.CLOSE') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="success" @click.native="startQuestionnaire" :disabled="!requiredInfoIntroduced">{{ $t('questionnaires.new.START') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDescriptionHelp" lazy transition="dialog-bottom-transition" max-width="60%">
      <v-card>
        <v-card-title class="headline">{{ $t('questionnaires.new.example.TITLE') }}</v-card-title>
        <v-divider></v-divider>

        <v-card-text v-html="$t('questionnaires.new.example.CONTENT1')">
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text v-html="$t('questionnaires.new.example.CONTENT2')">
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click.native="showDescriptionHelp = false">
            <span>{{ $t('questionnaires.new.example.CLOSE') }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-progress-circular v-bind:size="70" indeterminate class="primary--text" v-show="generalLoading"></v-progress-circular>
    <v-btn fab large bottom left fixed class="warning" v-on:click="$router.push({ name: 'Home' })"><v-icon>arrow_back</v-icon></v-btn>
    <loading v-model="loading" :message="$t('common.LOADING')"></loading>
  </v-layout>
</template>

<script>
  import {SchoolResource} from '../../api/school'
  import {QuestionnaireResource} from '../../api/questionnaire'
  import {SelfAssessmentResource} from '../../api/selfassessment'
  import {UserResource} from '../../api/user'
  import moment from 'moment'
  import 'moment/locale/ca'
  import 'moment/locale/es'
  import Loading from '@/components/common/Loading'
  import {GROUPS, LEVELS} from '../../api/utils'

  export default {
    name: 'questionnaires',
    components: {
      Loading
    },
    data () {
      const generateDict = function (arr) {
        var res = {}
        arr.forEach(function (item) {
          res[item.value] = item.text
        })
        return res
      }
      return {
        questionnaires: [],
        allQuestionnaires: [],
        search: '',
        levels: [],
        levelsMap: generateDict(LEVELS),
        groupsMap: generateDict(GROUPS),
        groups: [],
        subjects: [],
        headersExpert: [
          { text: this.$t('questionnaires.headers.DATE'), value: 'creationDate' },
          { text: this.$t('questionnaires.headers.TEACHER'), align: 'left', value: 'teacherName' },
          { text: this.$t('questionnaires.headers.SCHOOL'), align: 'left', value: 'schoolName' },
          { text: this.$t('questionnaires.headers.LEVEL'), align: 'left', value: 'level' },
          { text: this.$t('questionnaires.headers.GROUP'), align: 'left', value: 'group' },
          { text: this.$t('questionnaires.headers.SUBJECT'), align: 'left', value: 'subject' },
          { text: this.$t('questionnaires.headers.CONTRAST'), align: 'left', value: 'isControl' },
          { text: this.$t('questionnaires.headers.EXPERT'), align: 'left', value: 'expertName' }
        ],
        headersTeacher: [
          { text: this.$t('questionnaires.headers.DATE'), value: 'creationDate' },
          { text: this.$t('questionnaires.headers.LEVEL'), align: 'left', value: 'level' },
          { text: this.$t('questionnaires.headers.GROUP'), align: 'left', value: 'group' },
          { text: this.$t('questionnaires.headers.SUBJECT'), align: 'left', value: 'subject' },
          { text: this.$t('questionnaires.headers.ACTIVITY'), align: 'left', value: 'activityDescription' },
          { text: this.$t('questionnaires.headers.CONTINUE'), align: 'left', value: 'activityDescription' }
        ],
        sortOptions: {
          orderField: 'creationDate',
          direction: 'desc'
        },
        pagination: {
          sortBy: 'id',
          descending: true
        },
        popups: [],
        dialogUsing: false,
        loadingUsing: false,
        checkedUsing: false,
        showDialogSchoolTeacher: false,
        newQuestionnaire: {
          schoolId: '',
          teacherId: '',
          degree: '',
          faculty: '',
          subject: '',
          activityDescription: '',
          date: null,
          kidsNumber: null,
          evaluated: false
        },
        schools: [],
        teachers: [],
        teachersLoaded: false,
        loading: false,
        generalLoading: false,
        datemenu: false,
        teachersGroupClass: '',
        rowsPageItems: [10, 20, 30, { text: 'All', value: -1 }],
        teacherQuestionnaire: null,
        teacherQuestionnaireStarter: false,
        isNew: true,
        hasDate: null,
        hasKidsNumber: null,
        hasSubject: null,
        hasDegree: null,
        hasFaculty: null,
        showDialogEvaluated: false,
        showDescriptionHelp: false,
        locale: 'es'
      }
    },
    created () {
      this.loading = true
      this.setLocale()
      QuestionnaireResource().get().then(response => {
        const allQuestionnaires = response.body
        this.allQuestionnaires = allQuestionnaires
        const completedQuestionnaires = []
        for (const questionnaire of allQuestionnaires) {
          if (!questionnaire.isCompleted) completedQuestionnaires.push(questionnaire)
        }
        this.questionnaires = completedQuestionnaires
        this.loading = false
        if (this.questionnaires.length < 1) this.openStartDialog()
      }, response => {
        console.log(response)
        this.loading = false
      })
      if (this.$auth.check('TEACHER')) {
        UserResource().get({id: this.$auth.user().id}).then(
          response => {
            const teacher = response.data
            this.levels = teacher.levels != null ? teacher.levels : []
            this.groups = teacher.groups != null ? teacher.groups : []
            this.subjects = teacher.subjects != null ? teacher.subjects : []
          }
        )
      }
    },
    mounted () {
      SchoolResource().get().then(
        response => {
          this.schools = response.data
        },
        _ => {
          console.log('error in schools endpoint')
        }
      )
    },
    watch: {
      'newQuestionnaire.schoolId': function () {
        if (this.newQuestionnaire.schoolId !== '') {
          this.loading = true
          this.teachersLoaded = false
          this.newQuestionnaire.teacherId = null
          SchoolResource().getTeachers({id: this.newQuestionnaire.schoolId}).then(
            response => {
              this.teachers = response.data
              this.teachersLoaded = true
              this.loading = false
            },
            _ => {
              console.log('error in teachers endpoint')
            }
          )
        }
      },
      'newQuestionnaire.teacherId': function () {
        if (this.newQuestionnaire.teacherId !== '') {
          const teacher = this.findItemById(this.teachers, this.newQuestionnaire.teacherId)
          this.subjects = teacher.subjects != null ? teacher.subjects : []
        }
      },
      'teacherQuestionnaire': function () {
        if (this.teacherQuestionnaire !== 0) {
          QuestionnaireResource().get({id: this.teacherQuestionnaire}).then(
            response => {
              this.newQuestionnaire.date = response.body.creationDate

              this.newQuestionnaire.subject = response.body.subject
              this.newQuestionnaire.degree = response.body.degree
              this.newQuestionnaire.faculty = response.body.faculty

              this.newQuestionnaire.kidsNumber = response.body.kidsNumber
              this.newQuestionnaire.activityDescription = response.body.activityDescription
              this.newQuestionnaire.evaluated = response.body.isControlled
              this.hasDate = response.body.creationDate !== null
              this.hasKidsNumber = response.body.kidsNumber !== 0
              this.hasSubject = response.body.subject !== null
              this.hasDegree = response.body.degree !== null
              this.hasFaculty = response.body.faculty !== null
            },
            response => {
              console.log('error in questionnaires endpoint')
              console.log(response.body)
            }
          )
        }
      }
    },
    computed: {
      disableDatePicker: function () {
        return this.hasDate
      },
      disableKidsNumber: function () {
        return this.hasKidsNumber
      },
      disableDegree: function () {
        return this.hasDegree
      },
      disableFaculty: function () {
        return this.hasFaculty
      },
      disableSubject: function () {
        return this.hasSubject
      },
      orderedQuestionnairesList: function () {
        return this._.orderBy(this.questionnaires, this.sortOptions.orderField, this.sortOptions.direction)
      },
      schoolSelected: function () {
        return this.newQuestionnaire.schoolId !== '' && this.newQuestionnaire.schoolId !== null
      },
      canSelectTeacher: function () {
        return this.schoolSelected && this.teachersLoaded
      },
      teacherSelected: function () {
        return this.newQuestionnaire.teacherId !== '' && this.newQuestionnaire.teacherId !== null
      },
      requiredInfoIntroduced: function () {
        let ret = this.newQuestionnaire.activityDescription !== '' && this.newQuestionnaire.activityDescription !== null &&
          this.newQuestionnaire.date !== '' && this.newQuestionnaire.date !== null &&
          this.newQuestionnaire.kidsNumber !== '' && this.newQuestionnaire.kidsNumber !== null
        if (this.isNew) {
          if (this.$auth.check('EXPERT')) {
            ret = ret && this.schoolSelected && this.teacherSelected
          }
        }
        return ret
      },
      computedDate: function () {
        return this.newQuestionnaire.date | this.formatDate
      },
      canICreateAQuestionnaire: function () {
        return this.$auth.check('TEACHER')
      }
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment(String(value)).format('DD/MM/YYYY')
        }
      },
      formatFromUTC: function (value) {
        if (value) {
          const thisdate = new Date(value[0], value[1] - 1, value[2])
          return moment(thisdate).format('DD/MM/YYYY')
        }
      }
    },
    methods: {
      setLocale () {
        const currentLocale = this.$i18n.locale
        if (currentLocale === 'CA') {
          moment.locale('CA')
          this.locale = 'CA'
        } else {
          moment.locale('ES')
          this.locale = 'ES'
        }
      },
      openStartDialog: function () {
        this.showDialogSchoolTeacher = true
        this.hasDate = false
        this.hasKidsNumber = false
        this.hasSubject = false
        this.hasDegree = false
        this.hasFaculty = false
      },
      closeStartDialog: function () {
        this.showDialogSchoolTeacher = false
        this.teacherQuestionnaire = 0
        this.newQuestionnaire.schoolId = ''
        this.newQuestionnaire.teacherId = ''
        if (!this.$auth.check('TEACHER')) {
          this.newQuestionnaire.groupClass = ''
        }
        this.newQuestionnaire.activityDescription = ''
        this.newQuestionnaire.date = null
        this.newQuestionnaire.kidsNumber = null
        this.newQuestionnaire.evaluated = false
        this.teachers = []
        this.loading = false
        this.isNew = true
      },
      startQuestionnaire: function () {
        this.generalLoading = true
        const localDate = this.newQuestionnaire.date === null ? moment(new Date()).format('YYYY-MM-DD') : moment(new Date(this.newQuestionnaire.date)).format('YYYY-MM-DD')
        const model = {
          groupClass: this.newQuestionnaire.groupClass,
          activityDescription: this.newQuestionnaire.activityDescription,
          kidsNumber: this.newQuestionnaire.kidsNumber,
          creationDate: localDate,
          evaluated: this.newQuestionnaire.evaluated,
          degree: this.newQuestionnaire.degree,
          faculty: this.newQuestionnaire.faculty,
          subject: this.newQuestionnaire.subject
        }
        if (this.isNew) {
          SelfAssessmentResource().save({}, model).then(response => {
            this.generalLoading = false
            const newQuestionnaireId = response.body
            this.$router.push({name: 'Questionnaire', params: {questionnaireId: newQuestionnaireId}})
          }, response => {
            this.$emit('showSnackbar', response.body.message)
            this.generalLoading = false
          })
        } else {
          QuestionnaireResource()
            .saveDescription({id: this.teacherQuestionnaire}, model)
            .then(_ => {
              this.$router.push({name: 'Questionnaire', params: {questionnaireId: this.teacherQuestionnaire}})
            }, response => {
              this.$emit('showSnackbar', response.body.message)
            })
        }
      },
      startControlOfExisting: function (idQuestionnaire) {
        this.generalLoading = true
        QuestionnaireResource().createControlOfExisting({id: idQuestionnaire}, '').then(response => {
          this.generalLoading = false
          const newQuestionnaireId = response.body
          this.$router.push({name: 'Questionnaire', params: {questionnaireId: newQuestionnaireId}})
        }, response => {
          this.$emit('showSnackbar', response.body.message)
          this.generalLoading = false
        })
      },
      getGroupClass: function () {
        UserResource().get({id: this.$auth.user().id}).then(
          response => {
            const teacher = response.data
            return teacher.level + ' ' + this.$t('stage.' + teacher.stage)
          }
        )
      },
      openTeacherQuestionnaireStarter: function (id) {
        this.isNew = false
        this.teacherQuestionnaire = id
        this.showDialogSchoolTeacher = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/questionnaires/Questionnaires.vue